module.exports = __webpack_public_path__ + "static/media/SF-Compact-Text-Medium.384ff4ff.otf";